/**
 * 创建人：袁俊双
 * 时间：2020-10-20
 * 描述：级联面板
 * 使用说明: 参考 sw-cascader 配置应用说明文档
 */
import { Component, Input, Output, EventEmitter, OnInit, SimpleChange } from '@angular/core';
import { SwHttpClientService } from 'src/app/librarys/serves/sw-http-client.service';
import { SystemIdService } from 'src/app/librarys/serves/public/system-id.service';
import { SwCascaderOptions } from './sw-cascader';
import { SwCascaderService } from './sw-cascader.service';

@Component({
  selector: 'sw-cascader',
  templateUrl: './sw-cascader.component.html',
  styleUrls: ['./sw-cascader.component.css']
})
export class SwCascaderComponent implements OnInit {

  /**
   * 传入的树数据 格式{id: "1", text: "content", pid: "0",expanded:'true'}
   */
  @Input() datas: any[];

  /**
   * 传入的地址如果为bdp相关，需要再请求中加入此参数
   */
  @Input() isAdminQuery: boolean;
  /**
   * 选中的key值， 传入选中的Id值 ,回显
   */
  @Input() keySelected: string = '';

  /**
   * 异步加载的请求地址，没有则为同步加载，格式例如： 
   * 'http://192.168.10.96:8000/sw-basic/function/queryFunctionsByUserId?${pid}=${pidValue}&systemId=0546c13470857e36e03f6b2f9ab684d1'
   * 其中要注意的是： ${pid}=${pidValue} 这个字符串，其中 &{pid} 会被组件用 this.pid 代替；${pidValue}会被 this.parentId 代替
   */
  @Input() asyncUrl: string;

  /**
   * 异步请求的方式，针对部分请求数据不一的树
   */
  @Input() asyncParams: string;

  /**
   * 异步请求 主键输入
   */
  @Input() id: string = 'id';

  /**
   * 异步请求 父节点输入
   */
  @Input() pid: string = 'pid';

  /**
   * 异步请求 显示输入
   */
  @Input() text: string = 'text';

  /**
   * 父节点的值 用于异步 默认为0
   */
  @Input() parentId: string;

  /**
   * 盒子高度
   */
  @Input() height: string = '150px';

  /**
   * 盒子每个面板宽度
   */
  @Input() width: string = '180px';

  /**
   * 不要展示的节点(包括其子节点)的id字符串,用来解决bug: 禁止将自己的上级修改为子级的现下级及其本身，当字典数据为禁用时 下拉不显示
   */
  @Input() disabledNodeId:string = ""

  /**
   * 能展示但是不能选择的节点(包括其子节点)的id
   */
  @Input() readonlyNodeId:any[]  = []

  /**
   * 单选选择任意一级选项
   */
  @Input() radio: boolean = false

  /**
   * 能展示但是不能选择的节点(不包括其子节点)的id
   */
  @Input() readonlySelfId:any[]  = []

  /**
   * 传出选中的节点
   */
  @Output() voted = new EventEmitter();

  /**
   * 最底层节点带复选框
   */
  @Input() selectChildren: boolean = false;

  /**
   * 所有节点带复选框
   */
  @Input() allCanCheck: boolean = false;

  /**
   * 复选功能回显的id
   */
  @Input() multiNodeIds: any[] = [];

  /**
   * @ignore
   * 被选中的带复选框的最底层节点
   */
  multiNodes:any[] = []

  /**
   * 将平级数据-datas 处理为 树结构数据-nodes 
   * @ignore
   */
  nodes: any = [];

  /**
   * 将树结构数据-nodes 处理为 展示在页面上的数据-menus
   * @ignore
   */
  menus:any[] = []
  
  /**
    * 当前点击的节点
    */
  node: SwCascaderOptions; 

  /**
   * 当前点击节点的父节点
   * @ignore
   */
  parent:any[] = []

  /**
   * 父节点是否需要选中,假设是
   * @ignore
   */
  check:boolean = true

  /**
   * 父节点是否需要半选中,假设否
   * @ignore
   */
  halfCheck:boolean = false

  /**
   * @ignore
   * @param swCascaderService  树服务
   * @param http  http请求 
   * @param system  系统id
   */
  constructor(
    private swCascaderService: SwCascaderService, 
    private http: SwHttpClientService,
    private system: SystemIdService) { }

  /**
   * @ignore
   * 系统id
   */
  systemId = this.system.getSystemId();

  /**
   * @ignore
   */
  ngOnInit(): void {
    this.location();
  }

  /**
   * 重新加在异步请求
   */
  location() {
    this.systemId = this.system.getSystemId();
    if (this.asyncUrl) {
      //如果是异步
      let url = this.asyncUrl
      url = url.replace('${pid}',this.pid)
      url = url.replace('${pidValue}',this.parentId)
      this.http.Post(url, this.asyncParams).subscribe(data => {
        this.nodes = [];
        this.menus = []
        if(data.code == 200){
          let temp = data.data
          let levelPid = ""
          temp.forEach((dt,i) => {
            let node = new SwCascaderOptions();
            //填充主节点的数据
            levelPid = dt[this.pid]
            node.key = dt[this.id];
            node.title = dt[this.text];
            node.selected = false;
            node.halfSelected = false;
            node.expanded = false;
            node.parent = dt[this.pid];
            node.data = dt;
            node.children = [];
            this.nodes.push(node)
          });
          if(this.nodes.length){
            this.menus.push({pid:levelPid,level:1,data:this.nodes})
          }
        }
      })
    }
  }
  /**
   * 参数发生变化的时候构子
   * @ignore
   */
  ngOnChanges(simple:SimpleChange): void {
    if (this.datas != null || this.datas != undefined) {
      if (this.datas.length != 0) {
        //数据结构处理
        this.nodes = this.swCascaderService.toNodeOptions(this.datas, this.keySelected, this.id, this.pid, this.text, this.disabledNodeId, this.readonlyNodeId,this.readonlySelfId,this.selectChildren,this.allCanCheck,this.radio,this.multiNodeIds);
        this.menus = []
        this.menus.push({pid:this.nodes[0]['data'][this.pid],level:this.nodes[0]['level'],data:this.nodes})
        //根据初始化数据中的半选来决定展开几级面板
        this.initMenus(this.menus)

        //多选功能回显时 , this.multiNodes 数组中的已经选中的数据要手动加进去, 不然再勾选或取消勾选的时候, 抛出的 this.multiNodes 开始是空数组
        if(this.selectChildren || this.allCanCheck){  //如果启用了多选功能
          this.multiNodes = []
          this.initMultiData(this.nodes)  //初始化多选功能回显数据
        }

      } else {
        this.nodes = [];
      }
    } else if(simple['asyncUrl'] && this.asyncUrl && !this.datas){
      //如果是异步
      let url = this.asyncUrl
      url = url.replace('${pid}',this.pid)
      url = url.replace('${pidValue}',this.parentId)
      this.http.Post(url, this.asyncParams).subscribe(data => {
        this.nodes = [];
        this.menus = []
        if(data.code == 200){
          let temp = data.data
          let levelPid = ""
          temp.forEach((dt,i) => {
            let node = new SwCascaderOptions();
            //填充主节点的数据
            levelPid = dt[this.pid]
            node.key = dt[this.id];
            node.title = dt[this.text];
            node.selected = false;
            node.halfSelected = false;
            node.expanded = false;
            node.parent = dt[this.pid];
            node.data = dt;
            node.children = [];
            this.nodes.push(node)
          });
          if(this.nodes.length){
            this.menus.push({pid:levelPid,level:1,data:this.nodes})
          }
        }
      })
    }
  }

  /**
   * 初始化单选功能的 menus ，有 keySelected 就回显，有 openNode 就展开几级
   * @ignore
   * @param node 
   */
  initMenus(menus){
    let lastMenu = menus[menus.length-1]  //直接找到最后一级面板
    for (let j = 0; j < lastMenu['data'].length; j++) {  //遍历最后一级面板数据，
      let node = lastMenu['data'][j]
      if(node.halfSelected){  //如果该节点为半选，就说明它的子级有选中的，就展示子级面板 ； 或是 该节点要展开，就要展开子级
        let newIndex = this.menus.findIndex(m=>m.level == node['children'][0]['level'])
        if(newIndex != -1){  //如果面板中，已经有 该节点子级的级数了，就返回
          return false
        }
        this.menus.push({pid:node['key'],level:node['children'][0]['level'],data:node['children']})
        if(node['children'] && node['children']['length']){
          this.initMenus(this.menus)
        }
      }
    }
  }

  /**
   * 初始化多选功能回显数据
   * @ignore
   * @param node 
   */
  initMultiData(tree) {
    for (let i = 0; i < tree.length; i++) {
      if(tree[i].selected){  //只要是已经选中的数据,就加到 this.multiNodes 数组中
        this.multiNodes.push(tree[i])
      }
      if(tree[i].children && tree[i].children.length>0 && parent.length!=1){
        this.initMultiData(tree[i].children)  
      }
    }
  }
  
  /**
   * 点击节点文本，有下级就展开下级，没有下级就选中并抛出
   * @ignore 
   */
  clickText(node: SwCascaderOptions){
    // event.stopPropagation()  //禁止冒泡
    if(node.readonly){
      return false
    }
    this.node = node
    this.systemId =this.system.getSystemId();
    //如果是异步加载 切没有展开 下级没有数据执行查询获取下级数据
    if ( this.asyncUrl && !this.node.expanded && this.node.children.length == 0) {
      //1.先看点击的这个节点是第几级数据
      let index = this.menus.findIndex(v=>v.pid == this.node['data'][this.pid])
      //2.把该级菜单之后的都删除
      this.menus.splice(index+1)
      //通过节点的id 去查询他的下级数据
      let url = this.asyncUrl
      url = url.replace('${pid}',this.pid)
      url = url.replace('${pidValue}',this.node.key)
      this.http.Post(url, this.asyncParams).subscribe(data => {
           let nodes:any=[];
           //判断查询是否成功
           if(data["code"]==200){
             //获取的数据不为空
             if(data["data"] !=null && data["data"]['length']){
               //能查到子级就展开节点
              this.node.expanded = !this.node.expanded;
              data["data"].forEach(el => {
                //将数据循环传入
                let nd = new SwCascaderOptions();
                nd.key= el[this.id];
                nd.title =el[this.text];
                nd.parent = el[this.pid];
                nd.children = el.children || [];
                nd.data = el;
                nodes.push(nd)
              });
              this.node.children = nodes;
              this.menus.push({pid:this.node['key'],level:this.node.children[0]['level'],data:this.node.children})
              
             }else{
               //下级没有数据 就选中
              this.node.expanded = false
              this.node.children = []
              //将选中数据之外的全都不选中，且所有数据半选都为false
              this.cancelOtherSelected(this.nodes,node.key)
              //4.该节点没有子级，就将之就抛出
              this.node.selected = true  //该节点选中了
              //点击输出选中的节点
              this.keySelected = this.node.key;

              this.voted.emit(this.node)

              //将点击节点的所有父级的 halfSelected 都设置为 true
              this.parent = []   //点击节点的所有父级
              this.findParent(this.nodes,this.node)  //找到所有父级节点
              if(this.parent.length && this.node.selected){  //如果父级存在
                this.parent.forEach(v=>{  //遍历父级节点
                  this.refreshHalfSelected(this.nodes,v)  //将父级节点的 halfSelected 设置为true
                })
              }
              
              //先将所有的 expanded 都设置为 false
              this.cancelOtherExpanded(this.nodes)
              this.parent.unshift(this.node)  //在父级数组的最前面加上自己
              this.parent.forEach(v=>{  //遍历父级节点
                this.refreshExpanded(this.nodes,v)  //将该节点以及它的所有父级的 expanded 都设置为true，其他都设置为 false
              })
             }
        
           }
      })  
    } else {
      //同步
      //1.先看点击的这个节点是第几级数据
      let index = this.menus.findIndex(v=>v.pid == this.node['data'][this.pid])
      if(index != -1){
        if(this.radio){  
          //如果是 单选任一节点，点击文本时只展开，不选中
          //将树节点全部的 selected 和 halfSelected 都设置为 false，为单选服务
          // this.cancelOtherSelected(this.nodes,'')
          //2.把该级菜单之后的都删除
          this.menus.splice(index+1)
          //如果是单选任一节点，那么点击文本时，有下级的时候就展开,没有下级就什么都不做
          if(this.node.children && this.node.children.length){
            //3.该节点有子级，就展示下级数据
            // this.keySelected = "";  //没有选中的节点了
            // this.node.halfSelected = true  //展开的话就说明当前节点半选中了
            this.node.expanded = true
            this.menus.push({pid:this.node['key'],level:this.node.children[0]['level'],data:this.node.children})
          }
        } else if(this.selectChildren || this.allCanCheck){
          //多选功能时点击文本，只有展开面板的功能，不会选中数据
          //1.把该级菜单之后的都删除
          this.menus.splice(index+1)
          if(this.node.children && this.node.children.length){
            //2.该节点有子级，就展示下级数据
            this.keySelected = "";  //没有选中的节点了
            this.menus.push({pid:this.node['key'],level:this.node.children[0]['level'],data:this.node.children})
          }

        } else {
          //如果是单选最底层节点，就要展开面板或勾选数据
          //2.把该级菜单之后的都删除
          this.menus.splice(index+1)
          //如果是只能单选最底层节点
          if(this.node.children && this.node.children.length){
            //3.该节点有子级，就展示下级数据
            //将数据全都不选中，且所有数据半选都为false
            this.cancelOtherSelected(this.nodes,'')
            this.keySelected = "";  //没有选中的节点了
            // this.node.halfSelected = true  //展开的话就说明当前节点半选中了
            this.menus.push({pid:this.node['key'],level:this.node.children[0]['level'],data:this.node.children})
          } else {
            //将选中数据之外的全都不选中，且所有数据半选都为false
            this.cancelOtherSelected(this.nodes,node.key)
            //4.该节点没有子级，就将之就抛出
            this.node.selected = true  //该节点选中了
            //点击输出选中的节点
            this.keySelected = this.node.key;
            this.voted.emit(this.node)
          }
        } 
      }

      //点击文本时，不管是单选还是多选功能，都可以进行下面的操作
      //1.将点击节点的所有父级的 halfSelected 都设置为 true
      this.parent = []   //点击节点的所有父级
      this.findParent(this.nodes,this.node)  //找到所有父级节点
      
      if(this.parent.length && this.node.selected){  //如果父级存在
        this.parent.forEach(v=>{  //遍历父级节点
          this.refreshHalfSelected(this.nodes,v)  //将父级节点的 halfSelected 设置为true
        })
      }
      //2.将该节点以及它的所有父级的 expanded 都设置为true，其他都设置为 false
      this.cancelOtherExpanded(this.nodes)  //先将所有的 expanded 都设置为 false
      this.parent.unshift(this.node)  //在父级数组的最前面加上自己
      this.parent.forEach(v=>{  //遍历父级节点
        this.refreshExpanded(this.nodes,v)  //将该节点以及它的所有父级的 expanded 都设置为true，其他都设置为 false
      })
    }
    return false; //防止事件冒泡
  }

  /**
   * 点击单选框，能够单选任一级节点
   * @ignore
   */
  clickRadio(event,node: SwCascaderOptions){
    event.stopPropagation()  //禁止冒泡
    if(node.readonly){  //如果该节点是不能选中的，就直接 return
      return
    } else {
      this.node = node
      //4.该节点没有子级，就将之就抛出
      this.node.selected = true  //该节点选中了
      // //点击输出选中的节点
      this.keySelected = this.node.key;
      //将选中数据之外的全都不选中，且所有数据半选都为false
      this.cancelOtherSelected(this.nodes,node.key)
      this.voted.emit(this.node)
      //如果是单选任一节点，那么点击文本时，有下级的时候就展开,没有下级就什么都不做
      if(this.node.children && this.node.children.length){
        //1.先看点击的这个节点是第几级数据
        let index = this.menus.findIndex(v=>v.pid == this.node['data'][this.pid])
        //2.把该级菜单之后的都删除
        this.menus.splice(index+1)
        //3.该节点有子级，就展示下级数据
        // this.node.halfSelected = true  //展开的话就说明当前节点半选中了
        this.menus.push({pid:this.node['key'],level:this.node.children[0]['level'],data:this.node.children})
      }
        
      //将点击节点的所有父级的 halfSelected 都设置为 true
      this.parent = []   //点击节点的所有父级
      this.findParent(this.nodes,this.node)  //找到所有父级节点
      if(this.parent.length && this.node.selected){  //如果父级存在,且该节点选中了，就处理父级的半选中状态
        this.parent.forEach(v=>{  //遍历父级节点
          this.refreshHalfSelected(this.nodes,v)  //将父级节点的 halfSelected 设置为true
        })
      }
    
      //先将所有的 expanded 都设置为 false
      this.cancelOtherExpanded(this.nodes)
      this.parent.unshift(this.node)  //在父级数组的最前面加上自己
      this.parent.forEach(v=>{  //遍历父级节点
        this.refreshExpanded(this.nodes,v)  //将该节点以及它的所有父级的 expanded 都设置为true，其他都设置为 false
      })
    }
    return false; //防止事件冒泡
    
  }

  /**
   * 点击多选框--只选中最顶层节点
   * @param menus 要处理的数组
   * @ignore
   */
  clickCheckbox(event,node: SwCascaderOptions){
    this.node = node
    event.stopPropagation()  //禁止冒泡
    if(node.readonly){  //如果该节点是不能选中的，就直接 return
      return
    } else {
      //如果是多选最底层节点功能
      if(this.selectChildren){
        if(this.node.children && this.node.children.length){  //如果有子节点，就展开，且将子节点全部选中
          //1.先看点击的这个节点是第几级数据
          let index = this.menus.findIndex(v=>v.pid == this.node['data'][this.pid])
          //2.把该级菜单之后的都删除
          this.menus.splice(index+1)
          //3.该节点有子级，就展示下级数据
          // this.node.halfSelected = true  //展开的话就说明当前节点半选中了
          this.menus.push({pid:this.node['key'],level:this.node.children[0]['level'],data:this.node.children})
        }
        //不管有没有子级，都进行勾选或取消勾选操作,将该节点及其子级的 selected 和 有子级的节点都设置了一遍
        let activeTree = [this.node]
        this.checkOrCancelChildren(activeTree,!this.node.selected)
        //再次重新设置 所有节点的 halfSelected 状态，只要是子级都不选中的，就将其 selected 改为 true ,否则改为false且将 halfSelected 改为 true
        this.parent = []   //点击节点的所有父级
        this.findParent(this.nodes,this.node)  //找到所有父级节点,看父节点是否需要选中
        if(this.parent.length){  //如果父级存在
          this.parent.forEach(v=>{  //遍历父级节点
            this.check = true  //假设该父节点需要选中
            this.halfCheck = false  //假设该父节点不需要半选中
            this.refreshFatherStatus(v['children'])  //重置父节点的 选中和半选中状态
            v.selected = this.check  //重置父节点的选中状态
            v.halfSelected = this.halfCheck  //重置父节点的半选中状态
          })
        }
        //将选中结果抛出
        this.voted.emit(this.multiNodes)
      }
    }
    return false; //防止事件冒泡

  }

  /**
   * 单选功能：点击节点时，根据新选中的节点刷新 tree 中的 selected 和 halfSelected,将非选中的selecetd改为false,所有节点的halfSelected改为false
   * @param menus 要处理的数组
   * @ignore
   */
  cancelOtherSelected(tree,selectedKey){
    for (let i = 0; i < tree.length; i++) {
      tree[i].selected = tree[i].key == selectedKey  //只要不是选中节点的id就 不选中
      tree[i].halfSelected = false  //只要不是选中节点的id就 半选也取消
      if(tree[i]['children'] && tree[i]['children']['length']){  //还有子级就递归处理
        this.cancelOtherSelected(tree[i]['children'],selectedKey)
      }
    }
  }

  /**
   * 处理 expanded 展开属性，将所有节点的 expanded 都设置为 false
   * @param menus 要处理的数组
   * @ignore
   */
  cancelOtherExpanded(tree){
    for (let i = 0; i < tree.length; i++) {
      tree[i].expanded = false  //只要不是选中节点的id就 半选也取消
      if(tree[i]['children'] && tree[i]['children']['length']){  //还有子级就递归处理
        this.cancelOtherExpanded(tree[i]['children'])
      }
    }
  }

  /**
   * 处理 expanded 展开属性，将该节点以及它的所有父级的 expanded 都设置为true，其他都设置为 false
   * @param menus 要处理的数组
   * @ignore
   */
  refreshExpanded(tree,node){
    for (let i = 0; i < tree.length; i++) {
      if(tree[i].key == node.key && node['children'] && node['children']['length']) {  //找到了该节点，且有子级就将半选属性设置为 true
        tree[i]['expanded'] = true
        break
      }
      if(tree[i]['children'] && tree[i]['children']['length']){  //还有子级就递归处理
        this.refreshExpanded(tree[i]['children'],node)
      }
    }
  }

  /**
   * 根据节点找到其所有的父节点，放在 this.parent 数组中
   * @param menus 要处理的数组
   * @ignore
   */
  findParent(tree,node){
    if(node.parent){
      //找到该节点的所有父级
      for (let i = 0; i < tree.length; i++) {
        if(tree[i].key == node.parent){  //找到了该节点的父级，如果父级还有父级，就继续找
          this.parent.push(tree[i])  //找到了父级
          if(tree[i]['parent']){
            this.findParent(this.nodes,tree[i])
          }
        }
        if(tree[i]['children'] && tree[i]['children']['length']){  //还有子级就递归处理
          this.findParent(tree[i]['children'],node)
        }
      }
    }
  }

  /**
   * 单选功能：点击节点时，根据新选中的节点刷新 其所有父节点的 halfSelected
   * @param menus 要处理的数组
   * @ignore
   */
  refreshHalfSelected(tree,node){
    //遍历父级数组，将父级数组中对应的节点的 halfSelected 都改为false
    for (let i = 0; i < tree.length; i++) {
      if(tree[i].key == node.key){  //找到了该节点，就将半选属性设置为 true
        tree[i]['halfSelected'] = true
        break
      }
      if(tree[i]['children'] && tree[i]['children']['length']){  //还有子级就递归处理
        this.refreshHalfSelected(tree[i]['children'],node)
      }
      
    }
  }

  /**
   * 多选功能--只选中最底层节点：点击节点时，如果有子级就选中所有子级，没有子级，就只选中这个节点，并将结果抛出
   * @param menus 要处理的数组
   * @ignore
   */
  checkOrCancelChildren(tree,checked){
    for (let i = 0; i < tree.length; i++) {
      if(tree[i]['children'] && tree[i]['children']['length']){  //如果该节点有子级，就深入操作子级
        tree[i]['halfSelected'] = checked
        tree[i]['selected'] = checked
        this.checkOrCancelChildren(tree[i]['children'],checked)
      } else {
        //如果没有子级，就选中或取消选中
        tree[i]['selected'] = checked
        if(checked){
          //如果是选中,要先看选中数组中是否有此值，有的话，先删除，再加入
          //如果是取消勾选
          let index = this.multiNodes.findIndex(v=>v.key == tree[i]['key'])
          if(index  != -1){
            this.multiNodes.splice(index,1)
          }
          this.multiNodes.push(tree[i])
        } else {
          //如果是取消勾选
          let index = this.multiNodes.findIndex(v=>v.key == tree[i]['key'])
          if(index  != -1){
            this.multiNodes.splice(index,1)
          }
        }

      }  
    }
  }

  /**
   * 多选功能--只选中最底层节点：勾选或取消勾选节点之后，将该节点的父节点 选中和半选状态都刷新一遍，因为可能要自动勾选/取消勾选父级
   * @param menus 要处理的数组
   * @ignore
   */
  refreshFatherStatus(tree){
    for (let i = 0; i < tree.length; i++) {
      if(!tree[i]['selected']){  //只要有一个子节点没有选中，那么选中状态就是 false
        this.check = false
      } else {  //只要有一个子节点被选中，那么该父节点就半选中
        this.halfCheck = true
      }
      if(tree[i]['children'] && tree[i]['children']['length']){  //如果该节点有子级，就深入操作子级
        this.refreshFatherStatus(tree[i]['children'])
      }  
    }
  }
  
  /**
   * 点击多选框--选任一级节点
   * @param menus 要处理的数组
   * @ignore
   */
  clickCheckbox2(event,node: SwCascaderOptions){
    this.node = node
    event.stopPropagation()  //禁止冒泡
    if(node.readonly){  //如果该节点是不能选中的，就直接 return
      return
    } else {
      //如果是多选最底层节点功能
      if(this.allCanCheck){
        if(this.node.selected){
          //如果之前已经是选中状态，就取消选中
          this.node.selected = false
          //将此节点从要抛出的数组中删除
          let index = this.multiNodes.findIndex(v=>v.key == this.node.key)
          if(index != -1){
            this.multiNodes.splice(index,1)
          }
        } else {
          //如果之前没有选中，就改为选中状态，且将值加到要抛出的数组中
          this.node.selected = true
          this.multiNodes.push(this.node)
        }
        //然后修改改节点的所有父级的半选状态
        this.parent = []   //点击节点的所有父级
        this.findParent(this.nodes,this.node)  //找到所有父级节点,看父节点是否需要半选中
        if(this.parent.length){  //如果父级存在
          this.parent.forEach(v=>{  //遍历父级节点
            this.halfCheck = false  //假设该父节点不需要半选中
            this.refreshFatherHalf(v['children'])  //重置父节点的 选中和半选中状态
            v.halfSelected = this.halfCheck  //重置父节点的半选中状态
          })
        }
        
        //将选中结果抛出
        this.voted.emit(this.multiNodes)
      }
      
    }
    return false; //防止事件冒泡

  }

  /**
   * 多选功能--选任一级节点：只刷新所有父级节点的半选状态
   * @param menus 要处理的数组
   * @ignore
   */
  refreshFatherHalf(tree){
    for (let i = 0; i < tree.length; i++) {
      if(tree[i]['selected']){  //只要有一个子节点被选中，那么该父节点就半选中
        this.halfCheck = true
      }
      if(tree[i]['children'] && tree[i]['children']['length']){  //如果该节点有子级，就深入操作子级
        this.refreshFatherHalf(tree[i]['children'])
      }  
    }
  }
}
